import BackendService from './BackendService';

export default class YMMTService {
  static getYears({
    condition,
  }: {
    condition: string;
  }): Promise<{ id: number; name: string }[]> {
    return BackendService.get(
      `/ymmt/manually-added-vehicle/years?condition=${condition}`,
    );
  }

  static getMakes({
    condition,
    year,
  }: {
    condition: string;
    year: string;
  }): Promise<{ id: number; name: string }[]> {
    return BackendService.get(
      `/ymmt/manually-added-vehicle/makes/${year}?condition=${condition}`,
    );
  }

  static getModels({
    condition,
    year,
    make,
  }: {
    condition: string;
    year: string;
    make: string;
  }): Promise<{ id: number; name: string }[]> {
    return BackendService.get(
      `/ymmt/manually-added-vehicle/models/${year}/${make}?condition=${condition}`,
    );
  }

  static getTrims({
    condition,
    year,
    make,
    model,
  }: {
    condition: string;
    year: string;
    make: string;
    model: string;
  }): Promise<
    { id: number; name: string; modelCode?: string; trim?: string }[]
  > {
    return BackendService.get(
      `/ymmt/manually-added-vehicle/trims/${year}/${make}/${model}?condition=${condition}`,
    );
  }
}
